import { render, staticRenderFns } from "./ActiveAirframes.vue?vue&type=template&id=14954d8a&scoped=true&"
import script from "./ActiveAirframes.vue?vue&type=script&lang=ts&"
export * from "./ActiveAirframes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14954d8a",
  null
  
)

export default component.exports